/* istanbul ignore file: Directive */
'use strict';

customerZone.directive('wizardStepOverview', ['utils', '$q', function(utils, $q){

    return {
        scope: {},
        link: function(scope, element, attrs) {
            scope.wizard = utils.getOrCreate(scope.$parent, attrs.wizard,  function(){ return new jim.Wizard($q); });
            element.addClass('wizard-step-overview');
        },
        template: '<ol><li ng-repeat="step in wizard.steps" ng-if="step.enabled()" ' +
        'ng-class="step.state" ' +
        'data-step="{{step.name}}">{{step.name | translate | capitalize}}</li></ol>'
    };

}]);
